module.exports = __webpack_public_path__ + "static/media/catalogueImg6.7609e767.png";